export type HoldSeverityType = 'High' | 'Medium' | 'Low';
export type HoldDisplayLocationType =
  'homepage' | 'financial-aid' | 'records-registration';

export interface IHoldConfig {
  severity: HoldSeverityType;
  displayLocations: HoldDisplayLocationType[];
  studentMessage: string;
  resolution: string;
}

export const SEVERITY_ORDER: Record<HoldSeverityType, number> = {
  High: 1,
  Medium: 2,
  Low: 3,
};

/** Maps the last URL path segment to a display location. */
export const ROUTE_DISPLAY_MAP: Record<string, HoldDisplayLocationType> = {
  '': 'homepage',
  dashboard: 'homepage',
  finances: 'financial-aid',
  'record-registration': 'records-registration',
};
